export const LABEL = {
    LOGIN: "LOGIN",
    FRONTIER: "Frontier",
    SIGNIN_WITH_PING: "Sign In With Ping",
    CREATE_REQUEST: "Create Request",
    DASHBOARD: "Dashboard",
    MANAGE_GROUPS: "Manage Groups",
    VERTICALS: "Verticals",
    DEPARTMENTS: "Deparments",
    USERS: "Users",
    USER_ROLES: "User Roles",
    FORM_BUILDER: "Form Builder",
    FLOWS: "Flows",
    EMAIL_TEMPLATES: "Email Templates",
    REQUEST_OVERVIEW: "Requests Overview",
    TOTAL: "Total",
    COMPLETED: "Completed",
    PUBLISHED: "Published",
    NEW: "New",
    HOLD: "Hold",
    ONHOLD: "On Hold",
    CANCELLED: "Cancelled",
    REQUESTS: "Requests",
    SEARCH_REQUESTS: "Search Requests",
    VIEW_ANNOUNCEMENT: "View Announcement",
    REOPEN_REQUEST: "Reopen Request",
    SELECT_FLOW_FOR_YOUR_REQUEST: "Select Flow for your Request",
    SELECT: "Select",
    CREATEUSER: "Create User",
    EFFORT: "Effort",
    IMPACT: "Impact",
    "RISK METER": "Fatal Score",
    RISKSCORE: "Risk Score",
    UPDATE_STATUS: "Update Status",
  };
  